import React, { useContext, useState } from 'react';
import styles from "../SideBarStyles.module.css";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { DashboardInfoContext, DashboardInfoPayload } from "../../../Context/dashboardContext";
import downArrowImageSrc from '../../../Assets/subSectionDropDownArrow.svg';
import { ISideBarOptionList } from "./CustomListItems";


interface CustomListItemProps {
    sectionName: string;
    sectionId: string;
    isActive: boolean;
    activeSubSection: string | null;
    SectionIcon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    subSections: ISideBarOptionList[];
    handleSectionChange: (sectionName: string, subSectionName?: string) => void
}

const hasAdditionalSection = (url: string): boolean => {
    try {
        const pathname = new URL(url, window.location.origin).pathname.replace(/^\/+/, "");
        return pathname.split('/').filter(Boolean).length > 1; // Check if more than two path sections
    } catch (error) {
        console.error("Invalid URL:", error);
        return false;
    }
};

const CustomListItem: React.FC<CustomListItemProps> = (props) => {
    const {
        sectionName,
        sectionId,
        isActive,
        SectionIcon,
        subSections,
        activeSubSection
    } = props;

    const { isSidebarCollapsed: flagClosed } = useContext(DashboardInfoContext) as DashboardInfoPayload;

    const [isDropdownOpen, setIsDropdownOpen] = useState(true);

    const handleDropdownToggle = (e: React.MouseEvent<HTMLButtonElement> | React.TouchEvent<HTMLButtonElement>) => {
        e.stopPropagation(); // to Prevent the parent onClick event from firing
        setIsDropdownOpen((prev) => !prev);
    };

    const flagHasSubSections = subSections.length > 0;

    const handleSectionClick = (subSection?: string) => () => {
        // Handle if the section has additional subsections but not in the sidebar.
        if(isActive && hasAdditionalSection(window.location.href)) {
            props.handleSectionChange(sectionId, subSection);
        }

        if (isActive && !flagHasSubSections) {
            return;
        }
        if (subSection === "" && flagHasSubSections) {
            props.handleSectionChange(sectionId, subSections[0].componentName)
            return;
        }

        props.handleSectionChange(sectionId, subSection);
    }

    return (
        <React.Fragment>
            <ListItem
                className={`${isActive ? styles.listItemActive : styles.listItem} ${styles.listItemCommon}`}
                onClick={handleSectionClick("")}
            >
                <ListItemIcon
                    className={styles.listIconCtn}
                    sx={{ backgroundColor: isActive ? "#3B78CE" : "transparent" }}>

                    <SectionIcon className={`${styles.listIconStyles} ${isActive && styles.listIconStylesActive}` } />
                </ListItemIcon>
                {!flagClosed && <ListItemText className={styles.sectionNameTxt} primary={sectionName} />}
                {isActive && <>
                    <span className={styles.shape1}></span>
                    <span className={styles.shape2}></span>
                </>}

                {(!flagClosed && flagHasSubSections) && (
                    <button
                        onClick={handleDropdownToggle}
                        className={`${styles.dropdownButton}`}
                    >
                        <img
                            src={downArrowImageSrc}
                            alt="Toggle Dropdown"
                            className={`${styles.arrowIconSubSection} ${isDropdownOpen ? styles.open : styles.closed}`}
                        />
                    </button>
                )}
            </ListItem>
            {(!flagClosed && isDropdownOpen && isActive && flagHasSubSections) &&
                <ul className={`${styles.subSectionCtn} ${isDropdownOpen ? styles.open : ''}`}>
                    {subSections.map((subSection, index) => (
                        <li
                            key={index}
                            onClick={handleSectionClick(subSection.componentName)}
                            style={{ color: activeSubSection === subSection.componentName ? "#fff" : "rgba(255,255,255,0.5)"}}>
                            {subSection.itemName}
                        </li>
                    ))}
                </ul>}
        </React.Fragment>
    );
};

export default CustomListItem;
